import { isMobile } from 'react-device-detect';
import DesktopSubscriptionGrid from './DesktopSubscriptionGrid';
import { MobileSubscriptionGrid } from './MobileSubscriptionGrid';

export const SubscriptionGrid = () => (isMobile
  ? <MobileSubscriptionGrid />
  : <DesktopSubscriptionGrid />);
